import React, { useState } from 'react';
import { useBiometrics } from '../hooks/useBiometrics';

const BiometricContext = React.createContext({
	biometrics: '',
	iniciarCaptura: () => {}
});

const BiometricProvider = ({ intialContextValue, children }) => {
	const [newMessage, setNewMessage] = useState(null);

	const onMessage = (msg) => {
		setNewMessage({ ...msg });
	};

	const { biometricos, iniciarCaptura, biometricsState, setBiometricsState } =
		useBiometrics({
			onMessage
		});

	return (
		<BiometricContext.Provider
			value={{
				biometricos,
				iniciarCaptura,
				newMessage,
				biometricsState,
				setBiometricsState
			}}
		>
			{children}
		</BiometricContext.Provider>
	);
};

export { BiometricContext, BiometricProvider };
